import { Box, Typography } from '@mui/material'
import { formatMoney } from '../../../../helpers/utils'
import { UI_COLOR_TEXT_HEADING, UI_COLOR_TEXT_TITLE_ALT } from '../../../../constants/uiColors'
import { DEPOSIT_BALANCED_COLOR } from '../../../helpers/settlementDetailsTabConstants'

export default function SummaryLine({
  label,
  amount,
  strong = false,
  success = false,
  amountColor = null
}) {
  return (
    <Box display="flex" justifyContent="space-between" gap={2} py={0.75}>
      <Typography
        sx={{ color: UI_COLOR_TEXT_TITLE_ALT, fontSize: 12, fontWeight: strong ? 800 : 600 }}
      >
        {label.toUpperCase()}
      </Typography>
      <Typography
        sx={{
          color: amountColor || (success ? DEPOSIT_BALANCED_COLOR : UI_COLOR_TEXT_HEADING),
          fontSize: 13,
          fontWeight: strong ? 900 : 800
        }}
      >
        {formatMoney(amount || 0)}
      </Typography>
    </Box>
  )
}
